import { IIconProps, IIconSize } from "src/components/icons/IconProps";
const SvgUser = (props: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    height={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
  </svg>
);
export default SvgUser;
